/* @flow */
import React from 'react';
import LeadStore from 'stores/LeadStore';
import LeadActions from 'actions/LeadActions';
import CurrentUser from 'auth/CurrentUser';
import RequireUser from 'components/mixins/RequireUser';
import TymkModal from 'user/components/TymkModal.jsx';
import ShareRemindModal from 'user/components/ShareRemindModal.jsx';
import SettingsStore from 'stores/SettingsStore';
import { promiseSettings } from 'promises/userBootData';

const InviteModal = React.createClass({
  mixins: [
    RequireUser,
  ],

  statics: {
    prefetch: [
      function() {
        const leads = LeadStore.getLeads();
        if (leads.length === 0) {
          return LeadActions.loadLeads();
        }
        return leads;
      },
      promiseSettings,
    ],
  },

  getInitialState() {
    return {
      leads: LeadStore.getLeads(),
      settings: SettingsStore.getSettings(),
    };
  },

  closeModal() {
    this.props.onRequestHide();
  },

  render() {
    if (this.state.leads.length > 0) {
      return (
        <TymkModal
          {...this.props}
          leads={this.state.leads}
          triggeredContext="love_remind"
        />
      );
    } else {
      return (
        <ShareRemindModal
          {...this.props}
          user={CurrentUser.getUser()}
          settings={this.state.settings}
        />
      );
    }
  },
});

export default InviteModal;



// WEBPACK FOOTER //
// ./src/users/components/InviteModal.jsx